'use client'

import { SUGGESTED_CONDITIONS } from '@components/app/HomePage/SearchWidget/consts'
import { useEffect, useState } from 'react'
import { useSearchFacetValues } from './useSearchFacetValues'

interface UseConditionFacetRefinementResult {
  searchTerm: string
  selectedCondition?: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  setSelectedCondition: React.Dispatch<React.SetStateAction<string | undefined>>
  suggestions: string[]
}

const CONDITION_ATTRIBUTE = 'conditions'

export function useConditionFacetRefinement({
  initialCondition,
}: {
  initialCondition?: string
}): UseConditionFacetRefinementResult {
  // Set the active refinement and selected condition to the search term.
  const [searchTerm, setSearchTerm] = useState<string>(initialCondition ?? '')
  const [selectedCondition, setSelectedCondition] = useState<
    string | undefined
  >(initialCondition)

  // State to hold the suggestion list.
  const [suggestions, setSuggestions] = useState<string[]>(
    SUGGESTED_CONDITIONS.map((c) => c.condition),
  )

  const searchFacetValues = useSearchFacetValues({
    attribute: CONDITION_ATTRIBUTE,
    setResults: setSuggestions,
  })

  useEffect(() => {
    if (searchTerm && searchTerm !== initialCondition) {
      searchFacetValues(searchTerm)
    }
  }, [searchTerm, initialCondition, searchFacetValues])

  return {
    searchTerm,
    selectedCondition,
    setSearchTerm,
    setSelectedCondition,
    suggestions,
  }
}
